import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { useBaseFormSlot } from '../../slots/forms/form-context.js';
import '../../slots/summaries/summary-context.js';
import '../../slots/summaries/types.js';

const FormFieldsWithCart = ({ formName  })=>{
    const { Slots  } = useBaseFormSlot();
    const FormFieldsComponent = React.useMemo(()=>Slots[formName]
    , [
        Slots,
        formName
    ]);
    const { cart  } = Context.useCart();
    const cartConfig = React.useMemo(()=>{
        return {
            cartContainsContactLenses: cart === null || cart === void 0 ? void 0 : cart.contains.contactLenses,
            cartContainsSolutions: cart === null || cart === void 0 ? void 0 : cart.contains.solutions,
            cartContainsPrescriptionGlasses: cart === null || cart === void 0 ? void 0 : cart.contains.prescriptionGlasses,
            cartContainsSunglasses: cart === null || cart === void 0 ? void 0 : cart.contains.sunglasses,
            cartContainsSubscription: cart === null || cart === void 0 ? void 0 : cart.contains.subscription
        };
    }, [
        cart
    ]);
    if (!FormFieldsComponent) return null;
    return /*#__PURE__*/ React.createElement(FormFieldsComponent, {
        cartContainsContactLenses: cartConfig.cartContainsContactLenses,
        cartContainsSolutions: cartConfig.cartContainsSolutions,
        cartContainsSunglasses: cartConfig.cartContainsSunglasses,
        cartContainsSubscription: cartConfig.cartContainsSubscription,
        cartContainsPrescriptionGlasses: cartConfig.cartContainsPrescriptionGlasses
    });
};

export { FormFieldsWithCart };
//# sourceMappingURL=FormFieldsWithCart.js.map
